import React from "react";
import axios from "axios";

import { Button } from "shards-react";

class LearningResourceTypeForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
    };
  }

  onSubmit = (e) => {
    e.preventDefault();

    if (this.props.mode === "edit") {
      axios
        .put(
          `${
            process.env.REACT_APP_API_URL
          }/learning-resource-type/${localStorage.getItem("id")}`,
          {
            ...this.state,
          },
          { headers: { "x-access-token": localStorage.getItem("jwtToken") } }
        )
        .then((res) => {
          if (res.status === 200) {
            window.location.href = "/learning-resources-type";
          } else {
            console.log("error");
          }
        });
    } else {
      axios
        .post(
          `${process.env.REACT_APP_API_URL}/learning-resource-type`,
          {
            ...this.state,
          },
          { headers: { "x-access-token": localStorage.getItem("jwtToken") } }
        )
        .then((res) => {
          if (res.status === 200) {
            window.location.href = "/learning-resources-type";
          } else {
            console.log("error");
          }
        });
    }
  };

  componentDidMount() {
    if (this.props.mode === "edit") {
      axios
        .get(
          `${
            process.env.REACT_APP_API_URL
          }/learning-resource-type/${localStorage.getItem("id")}`,
          {
            headers: { "x-access-token": localStorage.getItem("jwtToken") },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            const resource = res.data.resource;
            delete resource._id;
            this.setState({ ...resource });
          } else {
            console.log("error");
          }
        });
    }
  }

  render() {
    const { title } = this.state;
    return (
      <React.Fragment>
        <section className="hero-section pt-50 pb-50">
          <div className="container">
            <div className="col-md-12 col-lg-12 ">
              <h1 className="event-title">
                {this.props.mode === "edit" ? "Edit" : "Add New"} Resource Type
              </h1>
              <div className="card login-signup-card shadow-lg mb-0">
                <div className="card-body px-md-5 py-5">
                  <form onSubmit={this.onSubmit}>
                    <label className="pb-1">Title</label>
                    <div className="input-group input-group-merge">
                      <input
                        type="text"
                        value={title}
                        onChange={(e) =>
                          this.setState({ title: e.target.value })
                        }
                        className="form-control"
                        placeholder=""
                        required
                      />
                    </div>
                    <Button type="submit" className="submit-btn">
                      Submit
                    </Button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}
export default LearningResourceTypeForm;
